import { environment } from '../../../environments/environment';

export const API_ENDPOINTS = {
  wordpress: {
    workplaces: 'workplaces',
    workplaceTypes: 'type-of-workplace',
  },
  cities: 'location_city',
  meetingRoomsQuery: 'api/sm/v1/daily-pass',
  meetingRoomAvailability: 'api/sm/v1/website/daily-pass/rooms/bookings/available',
  meetingRoomBookedSlots: 'api/sm/v1/website/daily-pass/rooms/bookings/slot_booked',
  meetingRoomCost: 'api/sm/v1/website/daily-pass/rooms/bookings/{roomId}/cost',
  meetingRoomBookingOrder: 'api/sm/v1/website/daily-pass/rooms/bookings/book-order/',
  dayPassAvailability: 'api/sm/v1/website/desk/daily-pass/buildings/{buildingName}/availability',
  dayPassBookingOrder: 'api/sm/v1/website/desk/daily-pass/booking',
  dayPassGuests: 'api/sm/v1/website/desk/daily-pass/guests',
  bookings: {
    list: 'api/sm/v1/website/bookings/list',
    counts: 'api/sm/v1/website/bookings/counts',
    dayPassDetails: 'api/sm/v1/website/desk/daily-pass/booking/{bookingId}',
    meetingRoomDetails: 'api/sm/v1/website/daily-pass/rooms/bookings/{bookingId}',
    meetingRoomCancel: 'api/sm/v1/website/daily-pass/rooms/bookings/cancel-booking',
    dayPassCancel: 'api/sm/v1/website/desk/daily-pass/booking/{bookingId}/cancel',
    meetingRoomReschedule:
      'api/sm/v1/website/daily-pass/rooms/bookings/{bookingId}/reschedule-booking',
    dayPassReschedule: 'api/sm/v1/website/desk/daily-pass/booking/{bookingId}/reschedule-booking',
    dayPassInvoice: 'api/sm/v1/website/desk/daily-pass/booking/{bookingId}/invoice',
    meetingRoomInvoice: 'api/sm/v1/website/daily-pass/rooms/bookings/orders/{orderId}/invoice',
  },
  auth: {
    sendSignupOtp: 'api/tenants/v1/emp/web/otp',
    verifySignupOtp: 'api/tenants/v1/emp/web/otp/verify',
    sendLoginOtp: 'api/tenants/v1/emp/web/login/otp',
    verifyLoginOtp: 'api/tenants/v1/emp/web/login/otp/verify',
    register: 'api/tenants/v1/emp/web/register',
  },
  kyc: {
    verify: 'api/cs/v1/users/kyc/verify',
    billingDetails: 'api/cs/v1/users/{userId}/billing_details',
  },
  profile: {
    details: 'api/cs/v1/users/website/{employeeId}',
    update: 'api/cs/v1/users/{employeeId}',
  },
  payments: {
    createOrder: 'api/payments/v1.1/order',
    success: 'api/payments/v1/charge',
    failure: 'api/payments/v1.1/cancel',
  },
} as const;

export function buildWordpressApiUrl(endpoint: string): string {
  const baseUrl = environment.api.wordpressBaseUrl.replace(/\/+$/, '');
  const cleanEndpoint = endpoint.replace(/^\/+/, '');

  return `${baseUrl}/${cleanEndpoint}`;
}

export function buildTenantApiUrl(endpoint: string): string {
  const baseUrl = environment.api.tenantUrl.replace(/\/+$/, '');
  const cleanEndpoint = endpoint.replace(/^\/+/, '');

  return baseUrl ? `${baseUrl}/${cleanEndpoint}` : `/${cleanEndpoint}`;
}
